// Phase 90: single source of truth for the app version. Reads from
// package.json via Vite's `define` at build time. If `__APP_VERSION__`
// isn't injected (e.g. unbranded test harness), fall back to the
// package.json literal so the footer never reads "undefined".
import pkg from '../../package.json';
export const APP_VERSION = (typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : pkg.version);
